import React, { useState, useEffect } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  useLocation,
} from 'react-router-dom';

import { AnimatePresence, motion } from 'framer-motion';

import Login from './components/Login';
import Admin from './components/Admin';
import SiteDashboard from './components/siteDashboard';
import AccountInfo from './components/accountInfo';
import MapPage from './components/MapPage';
import FaultData from './components/FaultData';
import RevenueAnalysis from './components/RevenueAnalysis';
import { auth } from './utils/firebase';
import LoadingScreen from './components/loadingScreen';
import SiteLayout from './components/SiteLayout';
import DataExporter from './components/dataExporter';

const PageFade = ({ children }) => (
  <motion.div
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    exit={{ opacity: 0 }}
    transition={{ duration: 0.3 }}
  >
    {children}
  </motion.div>
);

function AppContent({ currentUser }) {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route
          path="/"
          element={
            currentUser ? (
              <PageFade>
                <Admin currentUser={currentUser} />
              </PageFade>
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route path="/login" element={<PageFade><Login /></PageFade>} />
        <Route
          path="/admin"
          element={
            currentUser ? (
              <PageFade>
                <Admin currentUser={currentUser} />
              </PageFade>
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route
          path="/account-info"
          element={
            currentUser ? (
              <PageFade>
                <AccountInfo />
              </PageFade>
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route
          path="/site-dashboard/:siteName/:selectedDate"
          element={
            currentUser ? (
              <SiteLayout>
                <SiteDashboard currentUser={currentUser} />
              </SiteLayout>
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route
          path="/revenue-analysis/:siteName/:selectedDate"
          element={
            currentUser ? (
              <SiteLayout>
                <RevenueAnalysis />
              </SiteLayout>
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route
          path="/fault-data/:siteName/:selectedDate"
          element={
            currentUser ? (
              <SiteLayout>
                <FaultData />
              </SiteLayout>

            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route
          path="/map/:siteName/:selectedDate"
          element={
            currentUser ? (
              <SiteLayout>
                <MapPage />
              </SiteLayout>
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route
          path="/export/:siteName/:selectedDate"
          element={
            currentUser ? (
              <SiteLayout>
                <DataExporter />
              </SiteLayout>
            ) : (
              <Navigate to="/login" />
            )
          }
        />

        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </AnimatePresence>
  );
}

function App() {
  const [currentUser, setCurrentUser] = useState(null);
  const [authChecked, setAuthChecked] = useState(false);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      setCurrentUser(user);
      setAuthChecked(true);
    });

    return () => unsubscribe();
  }, []);

  if (!authChecked) {
    return <LoadingScreen />;
  }

  return (
    <Router>
      <AppContent currentUser={currentUser} />
    </Router>
  );
}

export default App;
